import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import { ResultIcons } from "@/assets/icons/ResultIcons";
import { useIsMobileView } from "@/contexts/ResponsiveProvider";
import { useTrans } from "@/utils/useTrans";
import { Button } from "@/v2-components/ui/button";
import Link from "next/link";
import PageTemplate from "@/components/templates/PageTemplate";

const ContactEmailPage = () => {
  const { t } = useTrans(["support"]);
  const isMobile = useIsMobileView();

  return (
    <PageTemplate>
      <PageTemplate.Content>
        <div className="text-222222">
          <div className="w-full px-5">
            <div className="mx-auto flex max-w-screen-mdl flex-col gap-y-6 py-[80px] text-center smd:gap-y-9 smd:py-[200px]">
              <div className="flex flex-col items-center gap-y-14 text-center">
                <ResultIcons.Success
                  width={isMobile ? 75 : 100}
                  height={isMobile ? 75 : 100}
                />
                <h2 className="text-6xl font-400 smd:text-7xl">
                  {t("Thank you for contacting us!")}
                </h2>
              </div>
              <h3 className="text-lg font-500 smd:text-3xl smd:font-400">
                {t("Your inquiry has been successfully received.")}
              </h3>
              <p className="whitespace-pre-line text-center text-base font-400 smd:text-lg">
                {t(
                  "We will review your message and get back to you as soon as possible but it may takes 3-5 business days for a response. ",
                )}
              </p>
              <Link href="/" className="flex items-center justify-center">
                <Button
                  variant={"blue-fill"}
                  className="hidden w-fit px-6 smd:flex"
                  size={"md"}
                  shape={"pill"}
                >
                  {t("Back to Homepage")}
                </Button>
                <Button
                  variant={"blue-fill"}
                  className="flex w-fit px-6 smd:hidden"
                  size={"sm"}
                  shape={"pill"}
                >
                  {t("Back to Homepage")}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </PageTemplate.Content>
    </PageTemplate>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["support", "gnb"])),
    },
  };
}

export default ContactEmailPage;
